import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_LIST_COUNTERPARTY = gql`
  query bankingCounterparties($filter: BankingCounterpartiesFilter!, $page: OffsetPageInput!) {
    bankingCounterparties(filter: $filter, page: $page) {
      bankingCounterparties {
        id
        name
        bank
        routingNumber
        accountNumber
        accountType
        type
        status
        connectedType
        fullAccountNumber
        fullRoutingNumber
        isACHSupported
        isWireSupported
        nickname
        firstName
        lastName
        wire {
          routingNumber
          address {
            street
            street2
            city
            state
            postalCode
            country
          }
        }
      }
      pageInfo {
        page
        pageSize
        hasNextPage
        totalCount
      }
    }
  }
`;

export const GET_COUNTERPARTY = gql`
  query bankingCounterparty($filter: BankingCounterpartyInput!) {
    bankingCounterparty(filter: $filter) {
      id
      name
      bank
      routingNumber
      accountNumber
      accountType
      type
      status
      connectedType
      fullAccountNumber
      fullRoutingNumber
      isACHSupported
      isWireSupported
      nickname
      firstName
      lastName
      wire {
        routingNumber
        address {
          street
          street2
          city
          state
          postalCode
          country
        }
      }
    }
  }
`;

export const GET_COUNTERPARTY_BALANCE = gql`
  query bankingCounterpartyBalance($filter: BankingCounterpartyInput!) {
    bankingCounterpartyBalance(filter: $filter) {
      id
      balance
      available
      currency
    }
  }
`;
